import './RouteError.scss'
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom'
import { MdOutlineHome, MdOutlineRefresh } from 'react-icons/md'
import { HttpError } from '../../api/types'
import { AccessDenied } from '../../auth'
import { Alert, Button } from '../../ui'

/**
 * Route `errorElement`: a thrown 403 shows access denied (ADR 0008), a 404
 * says so, anything else offers a retry. Replaces the portal's
 * CustomErrorBoundary, which never rendered (it needs a data router).
 */
export function RouteError() {
  const error = useRouteError()
  const navigate = useNavigate()
  const status =
    error instanceof HttpError
      ? error.status
      : isRouteErrorResponse(error)
        ? error.status
        : undefined

  if (status === 403) return <AccessDenied />

  const isNotFound = status === 404
  const message =
    error instanceof Error
      ? error.message
      : isRouteErrorResponse(error)
        ? error.statusText
        : undefined

  return (
    <div className="route-error">
      <Alert tone="danger" title={isNotFound ? 'Not found' : 'An error has occurred.'}>
        {isNotFound ? 'This record or page does not exist.' : message || 'Something went wrong.'}
      </Alert>
      <div className="route-error__actions">
        <Button
          variant="primary"
          icon={<MdOutlineRefresh />}
          onClick={() => {
            void navigate(0)
          }}
        >
          Try again
        </Button>
        <Button
          icon={<MdOutlineHome />}
          onClick={() => {
            void navigate('/')
          }}
        >
          Go to Dashboard
        </Button>
      </div>
    </div>
  )
}
